import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
} from "../../../services/index";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
declare var google;

@Component({
  selector: "Non-Ordered-Party",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./NonOrderedParty.html",
})
export class NonOrderedParty implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  gradeCtrl: FormControl = new FormControl();
  finyearCtrl: FormControl = new FormControl();

  gradeList = ["A", "B", "C", "D"];
  seasonList = [];
  dataList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  gridOptions: any;
  exceldata: any;
  finyearList = [];

  filter = {
    season_from_id: 0,
    fin_id: "4",
    season_to_id: 0,
    grade: "",
    season_from: "",
    season_to: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "agent",
    orderDir: "asc",
    fin_id: 4,
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @Input("params") params: any;

  seasonCtrlFrom: FormControl = new FormControl();
  seasonCtrlTo: FormControl = new FormControl();

  columns = [];
  toggleCol = [];
  seasonfinList = [];

  filterExpand = false;

  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private reportService: ReportService,
    public toasterService: ToasterService,
    public datePipe: DatePipe,
    private salesinvservice: SalesInvoiceService
  ) {}

  printConfig: any = {
    title: "Non Ordered Party report",
    columns: [],
    rows: [],
  };

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  ngOnInit(): void {
    //     this.loadSeasonList();
    this.LoadFinYearList();
    this.columns = [
      {
        name: "S.No",
        width: 50,
        minWidth: 50,
        maxWidth: 50,
        prop: "sno",
        //cellTemplate: this.snoTemplate,
        toggle: true,
        type: "sno",
      },
      {
        name: "Party name",
        width: 300,
        minWidth: 300,
        maxWidth: 300,
        prop: "party_name",
      },
      {
        name: "Agent name",
        width: 300,
        minWidth: 300,
        maxWidth: 300,
        prop: "agent_name",
      },
    ];

    this.toggleCol = Object.assign({}, this.columns);
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.pageCallback({ offset: 0 });
    this.getSeason();
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getAgentYearlyReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getAgentYearlyReport();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getAgentYearlyReport();
  }

  getAgentYearlyReport(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      grade: this.filter.grade,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      season_from_id: this.filter.season_from_id,
      season_to_id: this.filter.season_to_id,
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getNonOrderedPartyList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        // that.dataList = res.data;
        that.page.count = res.data.length;
        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.exceldata = that.getData(that.columns, res.data);
        //that.page.count = res.total;
        //that.refreshData();
        that.printConfig = {
          title: "Non Ordered Party report",
          columns: that.columns,
          rows: that.gridOptions.data,
        };
        //  that.columns = res.columns;
      });
  }
  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      //      that.loadSeasonList();
      window["finyear"] = that.finyearCtrl;
      that.finyearList = res.data;
      let fin = res.data[0]["fin_id"];
      if (that.params && that.params.data) {
        fin = that.params.data.fin_id;
      }
      that.filter.fin_id = fin;
      that.filter.fin_id = fin;
      that.finyearCtrl.setValue(fin);

      // this.getPartySalesOrder();
    });
  }

  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
    };
    this.salesinvservice.getSeason(params).then((res: any) => {
      this.seasonList = res;
      // this.partyCtrl.setValue(this.invoicedata['season']);
    });
  }
  selectSeason(season, season_range) {
    let that = this;
    that.seasonList.forEach(function (element) {
      if (season == element.season) {
        if (season_range == "season_from") {
          that.filter.season_from_id = element.season_id;
        }
        if (season_range == "season_to") {
          that.filter.season_to_id = element.season_id;
        }
      }
    });
  }
  onSelectFinyear(id) {
    let seasonfinList = _.filter(this.seasonList, { fin_id: id });
    this.seasonfinList = seasonfinList;
    this.seasonCtrlFrom.setValue(
      this.seasonList[this.seasonList["length"] - 1].season_id
    );
  }
  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season_name"];
    }
    return "";
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  clearFilter(): void {
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getAgentYearlyReport();
  }

  seasonFromFn(season: number) {
    let list: any[];
    let that = this;
    list = this.seasonList;
    let id = season && season["season_id"] ? season["season_id"] : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.filter.season_from_id = id;
      return fitem["season_name"];
    }
    return "";
  }

  seasonToFn(season: number) {
    let list: any[];
    let that = this;
    list = this.seasonList;
    let id = season && season["season_id"] ? season["season_id"] : 0;
    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      this.filter.season_to_id = id;
      return fitem["season_name"];
    }
    return "";
  }

  // loadSeasonList() {
  //     let that = this;
  //    // that.reportService.getNewSeasonList(this.filter)
  //         .then(function (res) {

  //             that.seasonList = res;
  //         });
  // }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/NonOrderedParty/NonOrderedParty.ts